import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import './Loans.css'
import LoanCard from '../../components/admin/LoanCard'
import PageTitle from '../../components/UI/PageTitle'
import Separator from '../../components/UI/Separator'
import { getAllLoans } from '../../api/Index'

const AdminLoans = () => {
  const navigate = useNavigate();
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllLoans = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await getAllLoans();
        setLoans(response.data);
      } catch (err) {
        setError(err.message);
        console.error('Error fetching all loans:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllLoans();
  }, []);
  const handleLoanClick = (loanId) => {
    navigate(`/loan-details?id=${loanId}`);
  };

  if (loading) {
    return (
      <div>
        <PageTitle title='Loans' />
        <div>Loading loans...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <PageTitle title='Loans' />
        <div style={{color: 'red'}}>Error: {error}</div>
      </div>
    );
  }

  return (
    <div>
        <PageTitle title='Loans' />
        <div className='loans-profile-container'>
            {loans.length === 0 ? (
              <div>No loans found.</div>
            ) : (
              loans.map((loan, index) => (
                <div key={loan._id || loan.id || index}>
                  <div onClick={() => handleLoanClick(loan._id || loan.id)} style={{cursor: 'pointer'}}>
                    <LoanCard {...loan} applicant={loan.user?.name || loan.applicant} />
                  </div>
                  <Separator />
                </div>
              ))
            )}
        </div>
    </div>
  )
}

export default AdminLoans